export * from './InceptIconProps';
